import React, { useEffect } from 'react'
import PageLayout from '../../layout/page_layout'
import { useParams } from 'react-router-dom'
import Container from '../../components/container'
import Box from '../../components/box'
import Tabs, { Tab } from '../../components/tabs'
import BasicInfoFragment from './basic_info'
import SpacesFragment from './spaces'
import HomeFragment from './home'
import { trackProfileView } from '../../utils/analytics'

enum ProfileViewPageTab {
  Home = 'Home',
  Availabilities = 'Availabilities',
  Spaces = 'Spaces'
}

const ProfileViewPage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<ProfileViewPageTab>(ProfileViewPageTab.Home)
  const {
    userId
  } = useParams() as { userId: string }

  useEffect(() => {
    console.log('ProfileViewPage: ' + userId)
    async function trackView (): Promise<void> {
      await trackProfileView(userId)
    }
    void trackView()
  }, [userId]);

  return (
    <PageLayout addGutter>
      <Container maxWidth="lg">
        <BasicInfoFragment userId={userId} />
        <Box mt={4}>
          <Tabs variant='fullWidth' indicatorColor='secondary' value={activeTab} onChange={(_, value) => { setActiveTab(value); }}>
            <Tab value={ProfileViewPageTab.Home} label={ProfileViewPageTab.Home} />
            <Tab value={ProfileViewPageTab.Spaces} label={ProfileViewPageTab.Spaces} />
            {/* <Tab value={ProfileViewPageTab.Availabilities} label={ProfileViewPageTab.Availabilities} /> */}
          </Tabs>
          <Box mt={2}>
            <Box hidden={activeTab !== ProfileViewPageTab.Home}>
              <HomeFragment userId={userId} />
            </Box>
            <Box hidden={activeTab !== ProfileViewPageTab.Spaces}>
              <SpacesFragment userId={userId} />
            </Box>
          </Box>
        </Box>
      </Container>
    </PageLayout>
  )
}

export default ProfileViewPage
